module.exports = __webpack_public_path__ + "media/images/help/access_profile_manage_1-04201d52ffd1e91f940dd28bfc70b80b.png";